




























import A from '@/utilities/alpha'
import ToggleSwitch from './ToggleSwitch.vue'
import CardDisplay from './CardDisplay.vue'
import Redactor from '../Redactor.vue'
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({
  components: {
    Redactor,
    CardDisplay,
    ToggleSwitch
  }
})

export default class SectionDisplay extends Vue {
  @Prop() section!: any
  @Prop() editable!: any
  @Prop() idx!: any
  @Prop() scrollPosition!: any
  @Prop({ required: true }) displayOrder!:number

  get extraClasses ():any {
    var classes = ''
    if (this.editable) {
      classes += ' editable'
    }
    if (!this.section.export) {
      classes += ' nonExport'
    }
    return classes
  }

  get description ():any {
    if (!this.editable && !A.stripHTML(this.section.description).trim()) {
      return false
    } else {
      return this.section.description
    }
  }

  get shouldShow ():any {
    // eslint-disable-next-line no-prototype-builtins
    return this.editable || (this.section.hasOwnProperty('export') && this.section.export) || (!this.section.hasOwnProperty('export') && !this.section.nonExport) // backwards compatibility
  }

  scrollNext () {
    this.$emit('scrollNext')
  }

  clickAsset (asset:any) {
    this.$emit('expandAsset', asset)
  }
}
